import { App, DealDetails, Offer } from 'app/console-api';
import { BodyText, FlexColumn, FlexRow } from '@make-software/cspr-design';
import React from 'react';
import { NavLink, generatePath } from 'react-router-dom';
import { PUBLIC_APP_VIEW_PATH } from 'app/route/paths';
import { StyledChipsTag } from 'app/components/common/common-styles';
import { GetPluginMetaByID } from 'app/components/management/common/plugins/plugin-metadata';
import { PluginChip } from 'app/components/management/common/plugins/plugin-chip/plugin-chip';

interface MyDealsListItemAppDataColumnProps {
  app: App;
  deal: DealDetails;
  offer: Offer;
}

export const MyDealsListItemAppDataColumn = (props: MyDealsListItemAppDataColumnProps) => {
  const isMyItem = props.app.id === props.deal.appID;
  const trafficType = isMyItem
    ? props.deal.requestType
    : props.deal.requestType === 'incoming'
      ? 'outgoing'
      : 'incoming';
  const pluginMeta = GetPluginMetaByID(props.offer.pluginID);
  return (
    <FlexColumn style={{ height: '100px' }} gap={4}>
      <FlexRow gap={34}>
        <BodyText size={3} scale={'sm'} variation={'darkGray'}>
          Partner:
        </BodyText>
        <FlexRow align={'center'} gap={4}>
          <BodyText size={3}>
            <NavLink to={generatePath(PUBLIC_APP_VIEW_PATH, { appId: props.app.id })}>
              {props.app.name}
            </NavLink>
          </BodyText>
        </FlexRow>
      </FlexRow>
      {props.offer.pluginID > 0 && (
        <FlexRow gap={8}>
          <BodyText size={3} scale={'sm'} variation={'darkGray'}>
            Task Type:
          </BodyText>
          <PluginChip id={props.offer.pluginID}></PluginChip>
        </FlexRow>
      )}
      <FlexRow gap={32}>
        <BodyText size={3} scale={'sm'} variation={'darkGray'}>
          Traffic:
        </BodyText>
        <StyledChipsTag gap={4}>
          <BodyText size={3}>{trafficType}</BodyText>
        </StyledChipsTag>
      </FlexRow>
    </FlexColumn>
  );
};
